import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Theater, Users, Star, CalendarDays, Archive } from "lucide-react";

function StatCard({ label, value, sub, icon: Icon, testid }) {
  return (
    <div data-testid={testid} className="rounded-lg border border-white/10 bg-[#0F0F0F] p-5">
      <div className="flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500">{label}</div>
        {Icon && <Icon className="w-4 h-4 text-gold" />}
      </div>
      <div className="mt-3 font-display text-4xl">{value}</div>
      {sub && <div className="mt-1 text-xs text-zinc-500">{sub}</div>}
    </div>
  );
}

export default function PlatformOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/platform/overview").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="text-zinc-500 text-sm">Loading…</div>;

  return (
    <div className="space-y-8" data-testid="platform-overview">
      <div>
        <div className="text-[10px] uppercase tracking-[0.24em] text-gold mb-1">Platform Admin</div>
        <h1 className="font-display text-4xl sm:text-5xl">Overview</h1>
        <p className="text-zinc-500 text-sm mt-2">A cross-tenant look at everything in the StageCall database.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard testid="stat-productions" label="Productions" value={data.productions.total} sub={`${data.productions.active} active · ${data.productions.archived} archived`} icon={Theater} />
        <StatCard testid="stat-users" label="Users" value={data.users.total} sub={`${data.users.admin} admin · ${data.users.staff} staff · ${data.users.cast} cast`} icon={Users} />
        <StatCard testid="stat-auditions" label="Audition submissions" value={data.auditions_total} sub="Across all productions" icon={Star} />
        <StatCard testid="stat-rehearsals" label="Rehearsals" value={data.rehearsals_total} sub="Total scheduled" icon={CalendarDays} />
      </div>

      <div className="rounded-lg border border-white/10 bg-[#0F0F0F] p-5">
        <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 mb-3 flex items-center gap-2">
          <Archive className="w-3.5 h-3.5" /> Role breakdown
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <RoleTile label="Super admin" value={data.users.super_admin} />
          <RoleTile label="Admin" value={data.users.admin} />
          <RoleTile label="Staff" value={data.users.staff} />
          <RoleTile label="Cast" value={data.users.cast} />
        </div>
      </div>
    </div>
  );
}

function RoleTile({ label, value }) {
  return (
    <div className="rounded border border-white/10 p-3 bg-[#0A0A0A]">
      <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">{label}</div>
      <div className="font-display text-2xl mt-1">{value}</div>
    </div>
  );
}
